import { render } from "./TextAreaSegment.vue?vue&type=template&id=13249e2c"
import script from "./TextAreaSegment.vue?vue&type=script&lang=js"
export * from "./TextAreaSegment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__